<div>
    <p>Authenticating Connection</p>
    <dx-load-indicator id="indicator"></dx-load-indicator>
</div>